import React from 'react';
import VideosYTube from '../containers/Videos/VideosYTube';
import Footer from '../containers/Footer/Footer';

const Videos = () => (
  <div style={{ background: 'var(--ck-bg, #0d0d0d)', minHeight: '100vh' }}>
    <VideosYTube />
    <Footer />
  </div>
);

export default Videos;
